export default __webpack_public_path__ + "static/media/Redux.0003ae67.png";